import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["percent", "yours", "partners"];
  static values = { productId: String };

  connect() {
    this.purchasePercentageInput = this.element.querySelector("#product_purchase_percentage");
    this.purchasePriceInput = this.element.querySelector("#product_purchase_price");
    this.currentPriceInput = this.element.querySelector("#product_product_current_price");
    this.currentOnlineShopSurchargePercentInput = this.element.querySelector("#product_online_shop_surcharge_percent");
    this.currentOnlineShopTotalPriceInput = this.element.querySelector("#product_online_shop_total_price");
    this.currentSellingPercentSwanInput = this.element.querySelector("#product_selling_percent_swan");
    this.currentSellingPriceSwanInput = this.element.querySelector("#product_selling_price_swan");
    this.currentBuyingPercentSwanInput = this.element.querySelector("#product_buying_percent_swan");
    this.currentBuyingPriceSwanInput = this.element.querySelector("#product_buying_price_swan");
    
    if (this.currentOnlineShopTotalPriceInput) {
      this.updateOnlineShopTotalPrice();
    }
    
    if (this.currentSellingPriceSwanInput) {
      this.updateSellingPriceSwan();
    }
    
    if (this.currentBuyingPriceSwanInput) {
      this.updateBuyingPriceSwan();
    }
  }

  calculate(e) {
    const input_value = e.target.value;

    if (input_value > 0 && input_value <= 7) {
      const partners = this.percent(input_value);
      const yours = (this.percent(7) - partners).toFixed(2);
      this.setInfoText(input_value, yours, partners);
    }
  }

  updatePurchasePercentage() {
    if (this.productIdValue === '4debbb3c-b28f-47ef-94f5-f431a9a40660') {
      return; // Skip calculation for NVM Pro Token
    }
    const purchasePercentage = parseFloat(this.purchasePercentageInput.value.replace(/,/g, "."));
    const currentPrice = parseFloat(this.currentPriceInput.value.replace(/\./g, "").replace(/,/g, "."));
    const calculatedPrice = currentPrice - (currentPrice * (purchasePercentage / 100));

    this.purchasePriceInput.value = calculatedPrice.toFixed(2);
  }

  updatePurchasePrice() {
    if (this.productIdValue === '4debbb3c-b28f-47ef-94f5-f431a9a40660') {
      return; // Skip calculation for NVM Pro Token
    }
    const currentPrice = parseFloat(this.currentPriceInput.value.replace(/\./g, "").replace(/,/g, "."));
    const calculatedPercentage = (((currentPrice - parseFloat(this.purchasePriceInput.value)) / currentPrice) * 100);

    this.purchasePercentageInput.value = calculatedPercentage.toFixed(2);
  }

  formatToTwoDecimals(event) {
    const input = event.target;
    const value = parseFloat(input.value.replace(/,/g, "."));
    if (!isNaN(value)) {
      input.value = value.toFixed(2);
    }
  }

  updateOnlineShopTotalPrice() {
    this.updateOnlineShopPriceWithPercentage(
      this.currentOnlineShopTotalPriceInput,
      this.currentOnlineShopSurchargePercentInput
    );
  }

  updateOnlineShopPriceWithPercentage(priceInput, percentInput) {
    if (this.productIdValue === '4debbb3c-b28f-47ef-94f5-f431a9a40660') {
      return; // Skip calculation for NVM Pro Token
    }
    const purchasePrice = this.parseInputValue(this.purchasePriceInput);
    const percentage = this.parseInputValue(percentInput);
    priceInput.value = (percentage > 0 ? purchasePrice * (1 + percentage / 100) : purchasePrice).toFixed(2);
  }
  
  updateSellingPriceSwan() {
    this.updatePriceWithPercentage(
      this.currentSellingPriceSwanInput,
      this.currentSellingPercentSwanInput
    );
  }
  
  updateBuyingPriceSwan() {
    this.updatePriceWithPercentage(
      this.currentBuyingPriceSwanInput,
      this.currentBuyingPercentSwanInput
    );
  }
  
  updatePriceWithPercentage(priceInput, percentInput) {
    if (this.productIdValue === '4debbb3c-b28f-47ef-94f5-f431a9a40660') {
      return; // Skip calculation for NVM Pro Token
    }
    const currentPrice = this.parseInputValue(this.currentPriceInput);
    const percentage = this.parseInputValue(percentInput);
    priceInput.value = (percentage > 0 ? currentPrice * (1 + percentage / 100) : currentPrice).toFixed(2);
  }
  
  parseInputValue(input) {
    return parseFloat(input.value.replace(/,/g, "."));
  }
  
  setInfoText(percen, yours, partners) {
    this.percentTarget.innerHTML = percen;
    this.yoursTarget.innerHTML = yours;
    this.partnersTarget.innerHTML = partners;
  }

  percent(value) {
    return (5000 * ( value / 100 )).toFixed(2);
  }
}
